import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile';
import { NavItem } from '@/app-shell/layout/Navigation/sidebar/nav-item';
import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { Zap } from 'lucide-react';
import { useCallback, useTransition } from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  label: {
    defaultMessage: 'Protocols',
    id: 'Quk/p/id7N',
    description: 'Sidebar nav entry linking to the protocols page',
  },
});

export const ProtocolsNavItem = () => {
  const intl = useIntl();
  const [, startTransition] = useTransition();
  const { dismissMobileSidebar } = useMobilePanel();

  const onClick = useCallback(() => {
    startTransition(() => {
      setSidebarOpenTab(undefined);
    });
    dismissMobileSidebar();
  }, [dismissMobileSidebar, startTransition]);

  return (
    <NavItem
      label={intl.formatMessage(messages.label)}
      icon={<Zap />}
      href="/protocols"
      onClick={onClick}
      testId="sidebar-link-protocols"
    />
  );
};
